import { render, staticRenderFns } from "./msCont.vue?vue&type=template&id=61f06b1c&scoped=true&"
import script from "./msCont.vue?vue&type=script&lang=js&"
export * from "./msCont.vue?vue&type=script&lang=js&"
import style0 from "./msCont.vue?vue&type=style&index=0&id=61f06b1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f06b1c",
  null
  
)

export default component.exports